import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/vexon/")({
  beforeLoad() {
    throw redirect({
      to: "/vexon/result",
      mask: {
        to: "/vexon",
      },
    });
  },
});
